import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import Home from "./pages/Home";
import Catalog from "./pages/Catalog";
import ChairDetail from "./pages/ChairDetail";
import Timeline from "./pages/Timeline";
import Designers from "./pages/Designers";
import DesignerProfile from "./pages/DesignerProfile";
import Movements from "./pages/Movements";
import MovementProfile from "./pages/MovementProfile";
import Identify from "./pages/Identify";
import Archive from "./pages/Archive";
import Admin from "./pages/Admin";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <div className="min-h-screen flex flex-col overflow-x-hidden">
        <Header />
        <main className="flex-1">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/catalog" element={<Catalog />} />
            <Route path="/chair/:slug" element={<ChairDetail />} />
            <Route path="/timeline" element={<Timeline />} />
            <Route path="/designers" element={<Designers />} />
            <Route path="/designers/:slug" element={<DesignerProfile />} />
            <Route path="/movements" element={<Movements />} />
            <Route path="/movements/:slug" element={<MovementProfile />} />
            <Route path="/identify" element={<Identify />} />
            <Route path="/chair-of-the-day/archive" element={<Archive />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
      </div>
      <Toaster position="top-center" richColors />
    </BrowserRouter>
  );
}
